<template>
  <div class="post-show-header">
    <div class="section pack">
      <div class="title" @click="onClickPackTitle">
        {{ itemPackTitle }}
        <span class="statistics">{{ itemPackNodeStatistics }}</span>
      </div>
    </div>
    <div class="content">
      <div class="action">
        <NodeCompleteAction :node="post" />
      </div>
      <h1 class="text">{{ post.title }}</h1>
    </div>
    <div class="section series">
      <router-link :to="seriesTitleLinkTo" class="link">
        {{ post.series.title }} （ 共 {{ post.series.packCount }} 集 ）
      </router-link>
    </div>
    <div class="section user">
      <UserAvatar :user="post.user" size="small" />
      <UserName :user="post.user" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import UserAvatar from '@/user/components/user-avatar';
import UserName from '@/user/components/user-name';
import NodeCompleteAction from '@/node/components/node-complete-action';

export default defineComponent({
  name: 'PostShowHeader',

  /**
   * 属性
   */
  props: {
    post: {
      type: Object,
    },
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 事件
   */
  emits: ['click'],

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentPosition: 'series/sideSheet/currentPosition',
    }),

    itemPackTitle() {
      return `第${this.post.pack.packIndex + 1}集 · ${this.post.pack.title}`;
    },

    itemPackNodeStatistics() {
      return `( ${this.post.nodeIndex + 1}  / ${this.post.pack.nodeCount} )`;
    },

    seriesTitleLinkTo() {
      return { name: 'seriesShow', params: { seriesId: this.post.series.id } };
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      openSideSheet: 'layout/openSideSheet',
      getSeriesCache: 'series/show/getSeriesCache',
    }),

    ...mapMutations({
      setCurrentPosition: 'series/sideSheet/setCurrentPosition',
    }),

    onClickPostTitle() {
      this.$emit('click');
    },

    async onClickPackTitle() {
      if (this.post.series) {
        await this.getSeriesCache(this.post.series.id);
        this.openSideSheet();

        const packId = `pack-${this.post.pack.id}`;

        if (this.currentPosition === packId) {
          this.setCurrentPosition(null);
          return;
        }

        this.setCurrentPosition(packId);
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    NodeCompleteAction,
    UserAvatar,
    UserName,
  },
});
</script>

<style scoped>
@import './styles/post-show-header.css';
</style>
